/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const APPOINTMENT_RECORD_DESTROY = gql`
  mutation appointmentRecordDestroy($records: [ID!] ) {
    appointment {
      records(destroy: $records) {
        records {
          id
        }

        errors
      }
    }
  }
`;
